import styled from "@emotion/styled";
import theme from "@utils/theme";

export const StyleOverviewCardWrapper = styled.div`
  border: 1px solid ${theme.orange.orange50};
  background-color: ${theme.colors.white};
  box-shadow: ${theme.colors.boxShadow};
  border-radius: 14px;
  width: 100%;
  height: auto;
`;

export const StyleOverviewCardHeader = styled.div`
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${theme.orange.orange50};
`;

export const StyleOverviewCardChildren = styled.div`
  padding: 18px 24px;
`;

export const StyleListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 30px;
`;

export const StyleListItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;
export const StyleImageWrapper = styled.div`
  border-radius: 8px;
  width: 60px;
  aspect-ratio: 1/1;
  border: 1px solid ${theme.orange.orange50};
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const StyleStatus = styled.div`
  padding: 8px 18px;
  border-radius: 8px;
  background-color: ${theme.orange.orange50};
  opacity: 0.6;
  font-size: 12px;
`;
